<header class="app-header" *transloco="let t">
    <div class="app-header__inner">
        <div
            class="app-header__left"
            [ngClass]="{ 'app-header__page-title': mode() === 'settings' || mode() === 'users' }"
        >
            @if (mode() === 'settings' || mode() === 'users') {
                <button
                    type="button"
                    class="header-slot__back"
                    (click)="goBack()"
                    [attr.aria-label]="mode() === 'settings' ? t('nav.settings') : t('nav.users')"
                >
                    <i class="bi bi-chevron-left" aria-hidden="true"></i>
                </button>
                <h1 class="header-slot__title">
                    {{ mode() === 'settings' ? t('nav.settings') : t('nav.users') }}
                </h1>
                @if (mode() === 'users') {
                    <button
                        type="button"
                        class="btn users-header__invite-inline"
                        (click)="triggerAction('inviteUser')"
                    >
                        <i class="bi bi-plus-lg" aria-hidden="true"></i>
                        <span>{{ t('users.inviteUser') }}</span>
                    </button>
                }
            } @else {
                <div class="app-header__brand-slot">
                    @if (mode() !== 'job-form') {
                        <a
                            [routerLink]="homeRoute"
                            class="app-header__brand"
                            [attr.aria-label]="t('app.title')"
                        >
                            <img
                                [src]="brandLogoUrl"
                                [alt]="t('app.title')"
                                class="app-header__brand-logo"
                            />
                        </a>
                    } @else {
                        <button
                            type="button"
                            class="header-slot__back"
                            (click)="goBack()"
                            aria-label="Go Back"
                        >
                            <i class="bi bi-chevron-left" aria-hidden="true"></i>
                        </button>
                    }
                </div>

                <nav class="app-header__nav" aria-label="Primary">
                    <ul class="header-nav">
                        @for (item of navItems; track item.id) {
                            <li class="header-nav__item">
                                <a
                                    [routerLink]="item.route"
                                    [class.is-active]="isActiveItem(item)"
                                    class="header-nav__link"
                                >
                                    {{ t(item.labelKey) }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            }
        </div>

        <div class="app-header__right">
            @if (mode() === 'blanks' || mode() === 'job-form') {
                <div class="app-header__action d-flex gap-2">

                    <button
                        type="button"
                        class="btn blanks-action-btn"
                        (click)="triggerAction('createNewBlank')"
                    >
                        <i class="bi bi-plus-lg" aria-hidden="true"></i>
                        <span>{{ t('blanks.createNewBlank') }}</span>
                    </button>
                    @if (mode() === 'blanks') {
                        <button
                            type="button"
                            class="btn blanks-action-btn"
                            (click)="triggerAction('importBlank')"
                        >
                            <app-svg-icon name="import-icon" />
                            <span>Import</span>
                        </button>
                    }
                </div>
            }


            <!-- <app-language-switcher /> -->

            @if (isMimic) {
                <div class="user-menu__item user-menu__item--mimic">
                    <span class="user-menu__item-icon" aria-hidden="true">
                        <i class="bi bi-question-circle"></i>
                    </span>
                    <span class="user-menu__item-label">Impersonate Mode Active</span>
                </div>
            }

            <button type="button" class="header-feedback-btn" (click)="openFeedback()">
                <svg class="help-icon" viewBox="0 0 24 24" aria-hidden="true">
  <circle cx="12" cy="12" r="9" />
  <path d="M9.75 9a2.25 2.25 0 1 1 3.9 1.5c-.6.6-1.65 1.2-1.65 2.25" />
  <circle cx="12" cy="16.5" r="0.75" class="dot" />
</svg>

            </button>

            <div ngbDropdown #userDropdown="ngbDropdown" placement="bottom-end" class="user-menu">
                <button
                    type="button"
                    class="app-header__avatar app-header__avatar--button"
                    [attr.title]="userName || userEmail || ''"
                    [attr.aria-label]="userName || userEmail || t('header.userMenu')"
                    (click)="userDropdown.toggle()"
                >
                    {{ userInitials }}
                </button>

                <button
                    type="button"
                    ngbDropdownToggle
                    class="user-menu__trigger"
                    [attr.aria-label]="t('header.userMenu')"
                >
                    <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>
                </button>

                <div ngbDropdownMenu class="user-menu__dropdown">
                    @for (item of userMenu(); track item.id) {
                        <button
                            type="button"
                            ngbDropdownItem
                            class="user-menu__item"
                            [class.user-menu__item--danger]="item.id === 'sign-out'"
                            (click)="onUserMenuClick(item)"
                        >
                            <span class="user-menu__item-icon" aria-hidden="true">
                                @if (item.icon.includes('.svg')) {
                                    <img
                                        [src]="item.icon"
                                        alt=""
                                        style="width: 16px; height: 16px"
                                    />
                                } @else {
                                    <i class="bi {{ item.icon }}"></i>
                                }
                            </span>
                            <span class="user-menu__item-label">{{ t(item.labelKey) }}</span>
                            @if (item.showChevron) {
                                <i
                                    class="bi bi-chevron-right user-menu__item-chevron"
                                    aria-hidden="true"
                                ></i>
                            }
                        </button>
                    }
                </div>
            </div>
        </div>
    </div>
</header>
